var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('v-container',{staticClass:"ml-auto",staticStyle:{"max-width":"960px"}},[_c('router-view')],1)],1),_c('v-snackbars',{attrs:{"snackbars":_vm.snackbars,"label-close":"Sluiten","label-next":"Volgende"},on:{"close":_vm.removeTopSnackbar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }